import * as React from "react";
import { forwardRef } from "react";
const SvgShield = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 18 18",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	d: "M8.6.6c2 1.8 4.8 2.8 7.5 2.7a10.7 10.7 0 0 1-7.5 13.3A10.7 10.7 0 0 1 1 3.3q4.3 0 7.6-2.7"
}));
const ForwardRef = forwardRef(SvgShield);
export default ForwardRef;
